import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { selectSiteUrl } from 'core/selectors/app';
import { selectIsDesktopMQ } from 'core/modules/MediaQueries/selectors';
import ComponentErrorBoundary from 'core/modules/ErrorBoundaries/ComponentErrorBoundary';
import { triggerAcquisitionBonusInfoBarBannerViewed } from './actions';

import './AcquisitionBonusInfoBarBanner.scss';

function AcquisitionBonusInfoBarBanner() {
  const isDesktopMQ = useSelector(selectIsDesktopMQ);
  const siteUrl = useSelector(selectSiteUrl);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(triggerAcquisitionBonusInfoBarBannerViewed());
  }, []);

  const mobileTitle = <a href={`${siteUrl}/signin`}>New Members: Earn 1,000 bonus miles</a>;

  const desktopTitle =
    (
      <>
        Start Shopping: Earn 1,000 bonus miles when you spend $25 in the next 2 weeks.&nbsp;
        <a href={`${siteUrl}/signin`}>See Details</a>
      </>
    );

  return (
    <div className="mn_acquisitionBonusInfoBarBanner">
      <h3>{isDesktopMQ ? desktopTitle : mobileTitle}</h3>
    </div>
  );
}

export default (props) => <ComponentErrorBoundary><AcquisitionBonusInfoBarBanner {...props} /></ComponentErrorBoundary>;
